(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  /*
    Scroll horizontal do breadcrumb no mobile:
    - ao carregar, a trilha começa alinhada à esquerda (ícone de Início visível) e o
      usuário desliza manualmente para ver o restante;
    - marca em data-overflow de que lado há conteúdo escondido, para o CSS esmaecer
      aquela borda.
  */
  if (!customElements.get('breadcrumbs-scroll')) {
    class BreadcrumbsScroll extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.breadcrumbs__list');
        if (!this.list) return;

        this.update = this.update.bind(this);
        this.list.addEventListener('scroll', this.update, { passive: true });
        this.resetToStart();
        this.update();
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.list);
      }

      disconnectedCallback() {
        if (!this.list) return;
        this.list.removeEventListener('scroll', this.update);
        this.resizeObserver?.disconnect();
      }

      /* Garante o início à esquerda, mesmo se o navegador restaurar a posição anterior do scroll */
      resetToStart() {
        const list = this.list;
        list.style.scrollBehavior = 'auto';
        list.scrollLeft = 0;
        list.style.scrollBehavior = '';
      }

      update() {
        const list = this.list;
        const maxScroll = list.scrollWidth - list.clientWidth;
        const atStart = list.scrollLeft <= 1;
        const atEnd = list.scrollLeft >= maxScroll - 1;

        if (maxScroll <= 1) {
          delete list.dataset.overflow;
        } else if (!atStart && !atEnd) {
          list.dataset.overflow = 'both';
        } else {
          list.dataset.overflow = atStart ? 'end' : 'start';
        }
      }
    }

    customElements.define('breadcrumbs-scroll', BreadcrumbsScroll);
  }

  } catch(e) { console.error(e); }
})();
})();
